import RestClient from '../../../lib/RestClient';

const URL = '/logistics/inventory/';

class LogisticsService {
    public getAllAccounts(
        sortColumn: String, sortOrder: String, pageToLoad: number, count: number, filter:string
    ) {
        return RestClient.get("/logistics-avalanche/account", {sortBy: sortColumn, sortDirection: sortOrder, page: pageToLoad, count: count, filter: filter});
    }

    public getAllInventoryData(sortColumn: String, sortOrder: String, pageToLoad: number, count: number, filter:string) {

        return RestClient.get(URL, {sortBy: sortColumn, sortDirection: sortOrder, page: pageToLoad, count: count, filter: filter});
    }

    public getMovementAggregations(kontoNr: String, ltNummer: String, sortColumn: String, sortOrder: String, page?: number, count?: number) {
        return RestClient.get(URL + kontoNr + "/" + ltNummer, {sortBy: sortColumn, sortDirection: sortOrder, page: page || 0, count: count || 1000});
    };

    public getMovementDataForAccountAndLTNumberAndMarket(kontoNr: String, ltNummer: String, markt: String, sortColumn: String, sortOrder: String, pageToLoad: number, count: number) {
        return RestClient.get(URL + kontoNr + "/" + ltNummer + "/" + markt, {sortBy: sortColumn, sortDirection: sortOrder, page: pageToLoad, count: count});
    }
}

const LogisticsServiceSingleton = new LogisticsService();

export default LogisticsServiceSingleton;
